import React, { useState } from 'react';
import loadable from '@loadable/component';
import Image from '../Image/Image';
import Modal from '../Modal/Modal';
import Button from '../form-elements/Button';
import { gripSymbols, tireLabels } from '../../../helpers/tiresHelper';

const TireInformationModalBody = loadable(() => import('./TireInformationModalBody'));

function TireInformationModal({ tire, adjusted = false }) {
    const [infoModalOpen, setInfoModalOpen] = useState(false);

    const getDynamicAriaLabel = () => {
        const labelValues = tireLabels.map(({ label, format }) => `${label}: ${format(tire)}`).join(', ');
        const presentGripSymbols = gripSymbols
            .filter(({ filter }) => filter(tire))
            .map(({ label }) => label)
            .join(' und ');
        
        const gripSymbolsText = presentGripSymbols ? `,${presentGripSymbols}` : '';
        return `Reifeninformationen: ${labelValues}${gripSymbolsText};EU Reifenlabel Modal öffnen für mehr Informationen`;
    };

    return (
        <>
            <Button className={`uk-text-muted ${adjusted ? "uk-width-1-1 uk-width-1-2@s" : "" }`} hideArrow onClick={() => setInfoModalOpen(true)} modifier="link" ariaLabel={getDynamicAriaLabel()}>
                <div className={`uk-grid uk-grid-small uk-child-width-auto uk-flex uk-flex-middle ${adjusted ? "uk-flex-center@s" : "" }`} data-uk-grid="">
                    {tireLabels.map(({ imgSrc, alt, format }, i) => (
                        <div key={i}>
                            <div className="uk-tile uk-tile-muted uk-padding-small uk-text-bold uk-text-large tireLabels_icons">
                                <Image src={imgSrc} alt={alt} /> <span>{format(tire)}</span>
                            </div>
                        </div>
                    ))}
                    {gripSymbols
                        .filter(({ filter }) => filter(tire))
                        .map(({ imgSrc, alt }, i) => (
                            <div key={i}>
                                <div className="uk-tile uk-tile-muted gripSymbols_icons" style={{ padding: '5px' }}>
                                    <Image resizeHeight={36} resizeWidth={36} src={imgSrc} alt={alt} />
                                </div>
                            </div>
                        ))}
                </div>
            </Button>
            <Modal fullWidth isOpen={infoModalOpen} contentLabel="Kontakt Modal" onRequestClose={() => setInfoModalOpen(false)}>
                <Button modifier="text" className="uk-modal-close-default" onClick={() => setInfoModalOpen(false)} ariaLabel="Modal schließen">
                    <i data-uk-icon="close" aria-hidden="true" />
                </Button>
                <div className="uk-modal-body">
                    <TireInformationModalBody />
                </div>
            </Modal>
        </>
    );
}

export default TireInformationModal;
